import type { Schemas } from "@softmax/observatory-client/types";

export type StartProgress = {
  readonly signedIn: boolean;
  readonly linked: boolean;
  readonly uploaded: boolean;
  readonly seated: boolean;
  readonly viewerName: string | null;
  readonly player: {
    readonly id: string;
    readonly name: string;
    readonly avatarUrl: string | null;
  } | null;
  readonly agentName: string | null;
  readonly policyName: string | null;
  readonly policyVersion: number | null;
  readonly policyArtifact: {
    readonly files: number;
    readonly sizeBytes: number | null;
    readonly kind: string | null;
  } | null;
  readonly experienceRequest: {
    readonly id: string;
    readonly status: Schemas["ExperienceRequestStatus"];
    readonly episodes: number;
    readonly completed: number;
    readonly failed: number;
  } | null;
  readonly leagueSubmission: {
    readonly id: string;
    readonly status: Schemas["LeagueSubmissionStatus"];
  } | null;
  readonly checkedAt: string;
};

export function emptyStartProgress(): StartProgress {
  return {
    signedIn: false,
    linked: false,
    uploaded: false,
    seated: false,
    viewerName: null,
    player: null,
    agentName: null,
    policyName: null,
    policyVersion: null,
    policyArtifact: null,
    experienceRequest: null,
    leagueSubmission: null,
    checkedAt: new Date().toISOString(),
  };
}
